// extracted by mini-css-extract-plugin
module.exports = {"root":"RangeSlider_root__2cIvm","activeHandle":"RangeSlider_activeHandle__1JUQM"};